// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"6c509176","703":"a47d8383"}[chunkId] + ".chunk.js";
};